import { Form, Popup } from 'devextreme-react';
import {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form';
import React, { useRef, useState } from 'react';
import '../../assets/bulk-modal.scss';
import { useTranslation } from '../../contexts/translation';
import { DocumentType } from '../../types/documentType.types';
import './TasksBulkEditModal.scss';

type Props = {
  documentTypes: DocumentType[];
  isVisible: boolean;
  mutate?: () => void;
  onClose: () => void;
  onSubmit: (data: any) => void;
};

export default function AssignedDocumentTypesModal({
  documentTypes,
  isVisible,
  mutate,
  onClose,
  onSubmit,
}: Props) {
  const { translate } = useTranslation();
  const transFormName = 'WorkActivityGroup.List';
  const formRef = useRef<Form>(null);

  const [formData, setFormData] = useState<any>({});

  /*   useEffect(() => {
    setFormData({ ...data, ...(actionType === DataGridActionType.Insert && { visible: true }) });
  }, []); */

  return (
    <Popup
      visible={isVisible}
      dragEnabled={false}
      closeOnOutsideClick={false}
      onHiding={onClose}
      showTitle
      title={translate!('Add assign to document type', transFormName)}
      width={'auto'}
      height={'auto'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formData);
        }}
      >
        <Form
          formData={formData}
          showColonAfterLabel={true}
          showValidationSummary={true}
          ref={formRef}
        >
          <GroupItem>
            <SimpleItem
              dataField="documentTypeId"
              editorType="dxSelectBox"
              editorOptions={{
                items: documentTypes,
                valueExpr: 'id',
                displayExpr: 'nameTranslated',
                // onValueChanged: handleCapacityCategoryChanged,
                width: 300,
              }}
            >
              <Label text={translate!('Document type', transFormName)} />
              <RequiredRule message={translate!('Document type is required', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={4}>
            <GroupItem colSpan={2}></GroupItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Save', '')}
                useSubmitBehavior
              />
            </ButtonItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Close', '')}
                onClick={onClose}
              />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </Popup>
  );
}
